<template>
    <div>
        <user-cancellation/>
    </div>
</template>

<script>
import UserCancellation from '@/components/UserCancellation'

export default {
    name: 'AigosmartHomeUserCancellationPage',
    components: {
        UserCancellation
        
    },
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>